/**
 * Filter Manager Module
 * Handles product filtering and tab functionality
 */

import { getAllElements, getElement } from '../core/utils.js';

export class FilterManager {
    constructor(system) {
        this.system = system;
        this.tags = null;
        this.filterItems = null;
        this.tagsWrapper = null;
    }

    init() {
        this.tags = getAllElements('.js-tag');
        this.filterItems = getAllElements('.js-filter-item');
        this.tagsWrapper = getElement('.tags-wrapper');

        if (this.tags.length > 0) {
            this.setupSmartTabVisibility();
            this.setupInitialState();
            this.setupEventListeners();
        }
    }

    setupSmartTabVisibility() {
        // Kontrollera om vi har smart tab-data tillgänglig
        if (typeof window.showProductInfoTabs === 'undefined') {
            return; // Ingen smart tab-data, använd standard beteende
        }
        
        const tabsWrapper = document.getElementById('product-info-tabs');
        if (!tabsWrapper) return;
        
        // Visa tabs-wrapper om det finns innehåll
        if (window.showProductInfoTabs) {
            tabsWrapper.style.display = 'block';
            
            // Visa relevanta individuella tabs
            if (window.hasSpecifications) {
                const specsTab = document.getElementById('specifications-tab');
                if (specsTab) specsTab.style.display = 'inline-block';
            }
            
            if (window.hasFiles) {
                const filesTab = document.getElementById('files-tab');
                if (filesTab) filesTab.style.display = 'inline-block';
            }
        }
    }

    setupInitialState() {
        // Om smart tabs är aktivt, hitta första synliga tab
        if (typeof window.showProductInfoTabs !== 'undefined' && window.showProductInfoTabs) {
            const firstVisibleTag = Array.from(this.tags).find(tag => 
                tag.style.display !== 'none' && 
                getComputedStyle(tag).display !== 'none'
            );
            
            if (firstVisibleTag) {
                firstVisibleTag.classList.add('tag-picked');
                const filterTag = firstVisibleTag.dataset.filtertag;
                
                // Visa motsvarande filter-item
                this.filterItems.forEach(item => {
                    item.style.display = item.dataset.tags === filterTag ? 'block' : 'none';
                });
                return;
            }
        }
        
        // Fallback till standard beteende
        if (this.tags[0]) {
            this.tags[0].classList.add('tag-picked');
        }

        // Dölj alla filter-items utom första
        this.filterItems.forEach((item, index) => {
            item.style.display = index === 0 ? 'block' : 'none';
        });
    }

    setupEventListeners() {
        // Tag-klick
        this.tags.forEach(tag => {
            tag.addEventListener('click', () => this.handleTagClick(tag));
        });

        // Toggle för tags-wrapper
        const toggleElements = getAllElements('.tags-heading, .js-tag');
        toggleElements.forEach(element => {
            element.addEventListener('click', () => this.toggleTagsWrapper());
        });
    }

    handleTagClick(clickedTag) {
        const filterTag = clickedTag.dataset.filtertag;
        
        // Dölj alla filter-items
        this.filterItems.forEach(item => {
            item.style.display = 'none';
        });

        // Visa matchande filter-items med fade-effekt
        const matchingItems = document.querySelectorAll(`.js-filter-item[data-tags="${filterTag}"]`);
        matchingItems.forEach(item => {
            item.style.display = 'block';
            item.style.opacity = '0';
            
            // Fade in-effekt
            setTimeout(() => {
                item.style.transition = 'opacity 0.5s ease';
                item.style.opacity = '1';
            }, 10);
        });

        // Uppdatera aktiv tag
        this.tags.forEach(tag => tag.classList.remove('tag-picked'));
        clickedTag.classList.add('tag-picked');
    }

    toggleTagsWrapper() {
        if (this.tagsWrapper) {
            this.tagsWrapper.classList.toggle('opened');
        }
    }
}
